exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".footer{margin-top:15px;background-color:#008bcd}.footer__copyright{font-size:.85rem;color:#afe0f4;line-height:40px}.footer__copyright-divider{margin:0 8px}.footer__copyright-link,.footer__copyright-link:visited{color:#afe0f4}.footer__copyright-link:active,.footer__copyright-link:focus,.footer__copyright-link:hover{color:#fff;text-decoration:none}.footer-container{width:75pc;margin:auto;display:flex;justify-content:center}.footer-timezone{display:inline-flex;align-items:center;margin-right:20px}.footer-copyright,.footer-timezone{font-size:.85rem;line-height:40px}.footer-copyright-divider{margin:0 8px}.footer-link{color:#777;-webkit-text-decoration:none,;text-decoration:none,}.footer-link:hover{text-decoration:underline;color:#999}.footer-powered-by{display:inline-flex;align-items:center;margin-left:20px;font-size:.85rem;line-height:40px}.footer-powered-by img{margin-top:3;margin-left:5}@media (max-width:480px){.footer__copyright{float:left!important}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/components/Footer/style.css
 ** module id = 1682
 ** module chunks = 0
 **/